/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaListDialogDefaultItemOption/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaListDialogDefaultItemOption({
  children,
  viewPath = "/DesignSystem/TysiaListDialog/TysiaListDialogItems/TysiaListDialogDefaultItemOption"
  
}) {
let itemNameValueData = fromData.useDataValue({ viewPath,
context: 'item',
path: 'name',
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textOverflow="ellipsis"
 whiteSpace="nowrap"
 overflowX="hidden"
 size="normal"
 weight="regular"
 data="item.name"
 text={itemNameValueData}
/>
{children}
</React.Fragment>)
}